"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protoToString = protoToString;
const protoClasses_1 = require("./protoClasses");
const proto_rpc_1 = require("@streamr/proto-rpc");
const typeRegistry = protoClasses_1.protoClasses.concat(proto_rpc_1.protoClasses);
function protoToString(protoObj, objectType) {
    let ret = '';
    try {
        ret = objectType.toJsonString(protoObj, {
            typeRegistry
        });
    }
    catch (_e) {
        ret = '[type not in type registry]';
    }
    return ret;
}
//# sourceMappingURL=protoToString.js.map